import { useEffect } from "react";
const PreventViewportZoomIn = () => {
  useEffect(() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    let originalViewportContent;
    if (isIOS) {
      const viewportMeta = document.querySelector('meta[name="viewport"]');
      originalViewportContent = viewportMeta == null ? void 0 : viewportMeta.getAttribute("content");
      viewportMeta == null ? void 0 : viewportMeta.setAttribute(
        "content",
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      );
    }
    return () => {
      if (isIOS) {
        const viewportMeta = document.querySelector('meta[name="viewport"]');
        if (viewportMeta && originalViewportContent) {
          viewportMeta.setAttribute("content", originalViewportContent);
        }
      }
    };
  }, []);
  return null;
};
export {
  PreventViewportZoomIn
};
